import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { QUERY_SERVICE } from '../../app.tokens';
import { AppHelper } from '../../helpers/app.helper';
import { IQueryService } from '../../interfaces/query.service';
import { NotificationService } from '../../services/notification.service';
import { TaxonomyService } from '../../services/taxonomy.service';
import { TaxonomyProcessor } from '../../services/taxonomy-processor';


@Component({
  selector: 'app-taxonomies',
  templateUrl: './taxonomies.component.html',
  styleUrls: ['./taxonomies.component.css']
})
export class TaxonomiesComponent implements OnInit, OnDestroy {
  private timerSubscription: Subscription;
  private inProcessCount: number = 0;

  taxonomies: TaxonomyProcessor[] = [];

  get isInProcess(): boolean {
    return this.inProcessCount !== 0;
  }

  get canAddNew(): boolean {
    return !this.taxonomies[this.taxonomies.length - 1].isInSelectMode;
  }

  constructor(
    @Inject(QUERY_SERVICE) private queryService: IQueryService,
    private taxonomyService: TaxonomyService,
    private appHelper: AppHelper,
    private notificationService: NotificationService,
    private ref: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.addNew();
    this.timerSubscription = interval(1000).subscribe(v => this.ref.detectChanges());
  }

  ngOnDestroy(): void {
    this.timerSubscription.unsubscribe();

    for (let i = 0; i < this.taxonomies.length; i++) {
      this.taxonomies[i].ngOnDestroy();
    }
  }

  addNew(): void {
    const processor = new TaxonomyProcessor(this.queryService, this.taxonomyService,
      this.appHelper, this.notificationService, this.taxonomies
        .filter(t => !t.isInSelectMode)
        .map(t => { return { clientId: t.selectedClient.id, taxonomyId: t.selectedTaxonomy.id }; }));

    this.taxonomies.push(processor);

    processor.isLoading$
      .pipe(
        filter(v => processor.selectedClient != null && processor.selectedTaxonomy != null))
      .subscribe(inProcess => {
        if (inProcess) {
          this.inProcessCount++;
        } else {
          this.inProcessCount--;
        }
      });

    processor.ngOnInit();
    processor.loadClients();
  }
}
